/**
 * svg renderer
 */
import { createHtmlElement } from '../utility/dom-util';
/** @private */
export class BarcodeSVGRenderer {
    /**
     * Draw the root element for the barcode.\
     *
     * @returns {HTMLElement} Draw the barcode SVG .
     * @param {Object} attribute - Provide the canvas element .
     * @private
     */
    // eslint-disable-next-line
    renderRootElement(attribute) {
        const canvasObj = createHtmlElement('canvase', attribute);
        return canvasObj;
    }
    /**
     * Draw the rect for the barcode.\
     *
     * @returns {HTMLElement} Draw the barcode SVG .
     *  @param {Object} canvas - Provide the canvas element .
     *  @param {Object} attribute - Provide the canvas element .
     * @private
     */
    // eslint-disable-next-line
    renderRect(canvas, attribute) {
        const canvasObj = createHtmlElement('canvase', attribute);
        return canvasObj;
    }
    /**
     * Draw the horizontal line for the barcode.\
     *
     * @returns {HTMLElement} Draw the barcode SVG .
     *  @param {Object} canvas - Provide the canvas element .
     *  @param {Object} attribute - Provide the canvas element .
     * @private
     */
    // eslint-disable-next-line
    renderLine(canvas, attribute) {
        const canvasObj = createHtmlElement('canvase', attribute);
        return canvasObj;
    }
    /**
     * Draw the text for the barcode.\
     *
     * @returns {HTMLElement} Draw the barcode SVG .
     *  @param {Object} canvas - Provide the canvas element .
     *  @param {Object} attribute - Provide the canvas element .
     * @private
     */
    // eslint-disable-next-line
    renderText(canvas, attribute) {
        const canvasObj = createHtmlElement('canvase', attribute);
        return canvasObj;
    }
}
